import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

interface Props {
    isDeletable?: boolean;
    isClickable?: boolean;
    isTruncate?: boolean;
    isIdChip?: boolean;
    size?: 'small' | 'medium';
    disableHover?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseChip',
  props: {
    isDeletable: { type: Boolean },
    isClickable: { type: Boolean },
    isTruncate: { type: Boolean },
    isIdChip: { type: Boolean },
    size: { default: 'small' },
    disableHover: { type: Boolean }
  },
  emits: ['click', 'delete'],
  setup(__props: any, { emit }) {

const props = __props as { isDeletable?: boolean, isClickable?: boolean, isTruncate?: boolean, isIdChip?: boolean, size: 'small' | 'medium', disableHover?: boolean }





const getClasses = computed(() => {
    const classes = {
        '--clickable': props.isClickable,
        '--id-chip': props.isIdChip,
        '--truncate': props.isTruncate,
        [`--${props.size}`]: props.size,
        '--hovered': !props.disableHover,
    };

    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const click = () => {
    // кнопка удаления с @click.stop сюда не доходит, поэтому доп. guard не нужен
    if (props.isClickable) {
        emit('click');
    }
};
const deleteChip = (e: Event) => {
    if (props.isDeletable) {
        emit('delete');
    } else {
        e.preventDefault();
    }
};


return { __sfc: true,props, emit, getClasses, click, deleteChip }
}

})